import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../consts/api";

export const useDeviceServices = (id, options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.deviceServicesAssigned, id],
    () => http.get(HTTP_ENDPOINTS.getDeviceServices(id)),
    { select: (res) => res.data.data, cacheTime: 0, ...options },
  );

  return res;
};
